import { ref } from '@vue/composition-api'

export default function useExerciseAttachment() {
  const attachmentExerciseId = ref(null)
  const editType = ref(null)
  const editingAttachment = ref(null)

  return {
    attachmentExerciseId,
    editType,
    editingAttachment,
  }
}
